import {useState} from 'react';
import PasswordResetMailSent from './PasswordResetMailSent';
import RequestPasswordReset from './RequestPasswordReset';

const ForgotPassword = () => {
    const [sentMail, setSentMail] = useState<boolean>(false);

    const sendMail = () => {
        setSentMail(true);
    };

    if (sentMail) {
        return <PasswordResetMailSent/>;
    }
    return <RequestPasswordReset onClick={sendMail}/>;
};

export default ForgotPassword;
